import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { emailSchema, phoneNumberSchema } from './schemas';

export type ICarePathInformationRequestValidated = {
    customControlData: IInformationRequestCustomControlDataValidated;
};

export interface IInformationRequestCustomControlDataValidated {
    availability?: string;
    carepaths: {
        cardiology: boolean;
        dermatology: boolean;
        mentalHealth: boolean;
        ophthalmology: boolean;
        somnology: boolean;
    };
    emailadres: string;
    phonenumber?: string;
}

export const carePathInformationRequestSchema: ISchemaContainer<ICarePathInformationRequestValidated> = {
    schema: Koi.object({
        customControlData: Koi.object({
            availability: Koi.string().max(255).optional().allow(''),
            carepaths: Koi.object({
                cardiology: Koi.boolean(),
                dermatology: Koi.boolean(),
                mentalHealth: Koi.boolean(),
                ophthalmology: Koi.boolean(),
                somnology: Koi.boolean(),
            }).custom((value) => {
                if (Object.values(value).includes(true)) {
                    return value;
                }
                throw new Error('at least one carepath has to be selected as true');
            }),
            emailadres: emailSchema,
            phonenumber: phoneNumberSchema.optional(),
        }),
    }).options({ convert: false, presence: 'required' }),
};
